import Crud from '../components/Highlight/Crud'
import Add from '../components/Highlight/Add'
import Edit from '../components/Highlight/Edit'

let routes = {
    path: '/highlight',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/highlight',
            component: Crud
        },
        {
            path: '/highlight/add',
            component: Add
        },
        {
            path: '/highlight/edit/:id',
            component: Edit
        },
    ]
}


export default routes


// WEBPACK FOOTER //
// ./src/router/highlight.js